<template>
  <nk-page :commercialAccess="['Sale', 'Warehouse']">
    <div class="h-100 d-flex flex-column">
      <div class="nk-card" style="height: 440px">
        <div style="height:100%">
          <nk-table v-model="selectedRow" :data="barcodesList" :options="componentOptions.tableOptions" :tabindex="102" ref="barcodesTable"></nk-table>
        </div>
      </div>
    </div>
  </nk-page>
</template>
<script>
  import _ from 'lodash'
  import validators, { isEmpty } from '~/statics/validators.js'
  import Input from '~/components/general/nikan-input.vue'
  import $sc from '~/plugins/shortcut.collection.js'
  import GenerateBarcodesByPattern from '@/components/form/barcode/generate-barcodes.vue'
  import emptyId from '~/statics/empty-id'

  export default {
    modal: {
      size: 'md',
      stateUID: 'product-floating-barcodes',
    },
    props: {
      data: { type: Object },
    },
    data() {
      return {
        barcodesList: [],
        componentOptions: {
          tableOptions: {
            editable: true,
            allowNewRow: true,
            searchBarEnabled: true,
            sortable: true,
            buttons: {
              addBtn: {
                options: {
                  visible: true
                }
              },
              deleteBtn: {
                options: {
                  visible: true
                }
              }
            },
            prepareNewRow: () => {
              return {
                value: '',
              }
            },
            columns: [
              {
                name: 'rowNumber',
                title: this.$t('row-number'),
                type: 'number',
                width: '50px',
                pinnable: false,
                pinned: true,
                entering: false,
                leaving: true,
              },
              {
                name: 'value',
                title: this.$t('barcode'),
                type: 'string',
                width: '400px',
                align: 'right',
                editable: true,
                type: 'string',
                serachable: true,
                view: {
                  options: {
                    format: (item) => item,
                  },
                },
                edit: (row, col) => {
                  return {
                    component: Input,
                    options: {
                      mode: 'string',
                    },
                  }
                },
                validators: validators('required'),
                entering: true,
                leaving: true,
              },
            ],
          },
        },
        saveBtn: {
          title: this.$t('save'),
          shortcut: $sc.find('save'),
          icon: 'save',
          isPrimary: false,
          handle(button, page, e) {
            this.save()
          },
        },
        generateBarcodeBtn: {
          title: this.$t('sale.product.f.productBarcode.generateByPattern'),
          shortcut: $sc.find('sum-till-current-row', 'table'),
          icon: 'barcode',
          isPrimary: false,
          handle(button, page, e) {
            this.showGenerateBarcodes()
          }
        },
        selectedRow: null,
      }
    },
    mounted() {
      this.barcodesList = this.data.barcodes.map(x => {
        return {
          value: x,
        }
      })
      this.prepareWindow(this.$t('sale.product.f.floating-barcodes'), [this.saveBtn, this.generateBarcodeBtn])
    },
    methods: {
      save() {
        return this.$refs.barcodesTable
          .commitChanges()
          .then((data) => {
            const resolveData = data.length > 0 ? data.filter(x => x.rowState !== 'deleted').map(x => x.value) : []
            this.resolve(resolveData)
          })
      },
      showGenerateBarcodes() {
        if (isEmpty(this.data?.mainProductId)) {
          this.$toast(this.$t('core.generate-pattern.m.product-must-be-already-saved'), { type: 'error' })
          return
        }
        this.showModal({
          component: GenerateBarcodesByPattern,
          options: {
            entitytType: 'ProductFloatingBarcode'
          },
          data: {
            entityId: this.data.mainProductId,
            productFloatings: [this.data.productFloating]
          }
        })
          .then((res) => {
            for (var item of res) {
              this.barcodesList.push(...item.barcodes.map(code => {
                return {
                  id: emptyId,
                  value: code,
                  rowState: "new"
                }
              }))
            }
          })
          .catch((err) => {
            console.log(err)
          })
      }
    },
  }
</script>
<style></style>
